/**
 * Stable CSS class names for E2E — Dynamic Request playground (URL, method, body, response).
 */
export const DR = {
    page: 'dynamic-request-page',
    fieldRequestUrl: 'dynamic-request-field--request-url',
    inputTextfieldRequestUrl: 'dynamic-request-input--textfield-request-url',
    fieldRequestType: 'dynamic-request-field--request-type',
    inputRadioGroupRequestType: 'dynamic-request-input--radio-group-request-type',
    fieldRequestParamType: 'dynamic-request-field--request-param-type',
    inputRadioGroupRequestParamType: 'dynamic-request-input--radio-group-request-param-type',
    fieldRequestBody: 'dynamic-request-field--request-body',
    inputTextfieldRequestBody: 'dynamic-request-input--textfield-request-body',
    actionsRow: 'dynamic-request-page__actions-row',
    inputButtonSendRequest: 'dynamic-request-input--button-send-request',
    responseSection: 'dynamic-request-page__response-section',
    responseTitle: 'dynamic-request-page__response-title',
    responsePre: 'dynamic-request-page__response-pre',
} as const;

export const drCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
